import { Singleton } from 'Core_Helpers/Singleton';
import { IStateStore } from 'Core_Helpers/IStateStore';
import { HolidayContentModalModuleStore } from './HolidayContent/HolidayContentModalModuleStore';
import { WhatsNewModalModuleStore } from './WhatsNew/WhatsNewModalModuleStore';
import { UpdateAppPromptModuleStore } from 'Stores/UpdateAppPromptModuleStore';
import { FoodBoxModalModuleStore } from './FoodBoxModal/FoodBoxModalModuleStore';
import { AppMigrationNotificationModalModuleStore } from './AppMigrationNotificationModal/AppMigrationNotificationModalModuleStore';
import { AppMigrationTakeoverModalModuleStore } from './AppMigrationTakeoverModal/AppMigrationTakeoverModalModuleStore';

/*
// The purpose of this store is to manage "app wide" modals.
// This store will determine which modals are shown and the order of presedence they have.
*/

export class ModalModuleStore extends Singleton implements IStateStore {
  private HolidayContentModalModuleStore = HolidayContentModalModuleStore.Instance();
  private WhatsNewModalModuleStore = WhatsNewModalModuleStore.Instance();
  private updateAppModalStore = UpdateAppPromptModuleStore.Instance();
  private FoodBoxModalModuleStore = FoodBoxModalModuleStore.Instance();
  private AppMigrationNotificationModalModuleStore = AppMigrationNotificationModalModuleStore.Instance();
  private AppMigrationTakeoverModalModuleStore = AppMigrationTakeoverModalModuleStore.Instance();
  private modalsShownCount = 0;

  constructor() {
    super();
  }

  public Use = () => {
    return this;
  };

  public async initialize() {
    // the order here dictates the precedence of modals
    // App migration modals have the highest priority and override all other modals
    if (this.AppMigrationTakeoverModalModuleStore.readyForDisplay()) {
      this.AppMigrationTakeoverModalModuleStore.open();
    } else if (this.AppMigrationNotificationModalModuleStore.readyForDisplay()) {
      this.AppMigrationNotificationModalModuleStore.open();
    } else if (await this.updateAppModalStore.readyForDisplay()) {
      this.updateAppModalStore.open();
    }
    // Temporarily disabled due to production bug
    // else if (this.modalsShownCount == 0 && this.FoodBoxModalModuleStore.readyForDisplay()) {
    //   this.FoodBoxModalModuleStore.open();
    //   this.modalsShownCount = this.modalsShownCount + 1;
    // }
    else if (this.modalsShownCount == 0 && this.WhatsNewModalModuleStore.readyForDisplay()) {
      this.WhatsNewModalModuleStore.open();
      this.modalsShownCount = this.modalsShownCount + 1;
    } else if (this.modalsShownCount == 0 && this.HolidayContentModalModuleStore.readyForDisplay()) {
      this.HolidayContentModalModuleStore.open();
      this.modalsShownCount = this.modalsShownCount + 1;
    }
  }
}
